import React from 'react';
import { View, Pressable, StyleProp, ViewStyle, TextStyle } from 'react-native';
import { useOnHover } from '@/hooks/useOnHover';
import { Text } from '@/components/Text';
import { styles } from './styles';
import { useOnFocus } from '@/hooks/useOnFocus';

interface RadioButtonProps {
  isSelected: boolean;
  onPress: () => void;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
  label?: string;
  labelStyle?: StyleProp<TextStyle>;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  isSelected = false,
  onPress,
  disabled = false,
  style,
  label,
  labelStyle,
}) => {
  const { isFocused, handleFocus, handleBlur } = useOnFocus(disabled);
  const { isHovered, handleHoverIn, handleHoverOut } = useOnHover();

  const getOuterStyle = () => {
    let stateStyle;

    if (disabled) {
      stateStyle = isSelected
        ? styles.disabledOuterSelected
        : styles.disabledOuter;
    } else if (isSelected) {
      if (isFocused) stateStyle = styles.selectedFocusedOuter;
      else if (isHovered) stateStyle = styles.selectedHoverOuter;
      else stateStyle = styles.selectedDefaultOuter;
    } else {
      if (isFocused) stateStyle = styles.focusedOuter;
      else if (isHovered) stateStyle = styles.hoverOuter;
      else stateStyle = styles.defaultOuter;
    }

    return [styles.outerCircle, stateStyle];
  };

  const getInnerStyle = () => {
    if (!isSelected) return null;
    if (disabled) return [styles.innerDot, styles.disabledInner];
    return styles.innerDot;
  };

  return (
    <Pressable
      onPress={disabled ? undefined : onPress}
      onHoverIn={handleHoverIn}
      onHoverOut={handleHoverOut}
      onFocus={handleFocus}
      onBlur={handleBlur}
      style={[styles.radioContainer, style]}
    >
      <View style={[styles.focusWrapper, isFocused && styles.focusOutline]}>
        <View style={getOuterStyle()}>
          {getInnerStyle() && <View style={getInnerStyle()} />}
        </View>
      </View>
      {label && <Text style={[styles.label, labelStyle]}>{label}</Text>}
    </Pressable>
  );
};

export default RadioButton;
